import { getSlidesPerView } from "./getSlidesPerView";
import { isSlidesLoopEnabled } from "./isSlidesLoopEnabled";
export var getIndex = function getIndex(_ref) {
  var _instanceRef$current$, _instanceRef$current;
  var instanceRef = _ref.instanceRef,
    isAtTheEnd = _ref.isAtTheEnd,
    isAtTheStart = _ref.isAtTheStart,
    setIsAtTheEnd = _ref.setIsAtTheEnd,
    setIsAtTheStart = _ref.setIsAtTheStart,
    slider = _ref.slider,
    slidesCount = _ref.slidesCount,
    type = _ref.type;
  var currentSlide = (_instanceRef$current$ = (_instanceRef$current = instanceRef.current) === null || _instanceRef$current === void 0 ? void 0 : _instanceRef$current.track.details.rel) !== null && _instanceRef$current$ !== void 0 ? _instanceRef$current$ : 0;
  var slidesLoopEnabled = isSlidesLoopEnabled(slider);
  var slidesPerView = getSlidesPerView(slider);
  if (type === 'next') {
    if (Boolean(slidesLoopEnabled) && isAtTheEnd) {
      setIsAtTheEnd(false);
      setIsAtTheStart(true);
      return 0;
    }
    if (currentSlide + slidesPerView >= slidesCount - slidesPerView) {
      setIsAtTheEnd(true);
      setIsAtTheStart(false);
      return slidesCount - slidesPerView;
    }
    setIsAtTheEnd(false);
    setIsAtTheStart(false);
    return currentSlide + slidesPerView;
  }
  if (slidesLoopEnabled && isAtTheStart) {
    setIsAtTheEnd(true);
    setIsAtTheStart(false);
    return slidesCount - slidesPerView;
  }
  if (currentSlide - slidesPerView <= 0) {
    setIsAtTheEnd(false);
    setIsAtTheStart(true);
    return 0;
  }
  setIsAtTheEnd(false);
  setIsAtTheStart(false);
  return currentSlide - slidesPerView;
};
//# sourceMappingURL=getIndex.js.map